import { Component, Inject } from '@angular/core';
import {
  MatSnackBarLabel,
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA
} from '@angular/material/snack-bar';

@Component({
  selector: 'custom-snackbar',
  templateUrl: './snackbar-notification.component.html',
  styleUrls: ['./snackbar-notification.component.css'],
  standalone: true,
  imports: [MatSnackBarLabel],
})
export class SnackbarNotification {
  snackBarRef = Inject(MatSnackBarRef);

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}